import React, { useEffect, useState } from "react";
import { getFormObj, server_domain } from "../../../services/constants";
import { setError } from "../../../redux/appsettingSlice";
import { useDispatch, useSelector } from "react-redux";
import { post } from "../../../services/axios";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import ExtendCheckoutForm from "./ExtendCheckoutForm";
import { IoIosClose } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const ExtendModal = ({ amount, show, close, id, reload, email }) => {
  const [clientSecret, setClientSecret] = useState("");
  const [stripePromise, setStripePromise] = useState(null);
  const [orderCompleteMessage, setOrderCompleteMessage] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const user_id = user?.user_id;

  const { isAuthenticated } = useSelector((state) => state.auth);

  const getStripeIntent = async () => {
    let rdata = getFormObj();
    rdata.append("api_method", "redeem_voucher");
    rdata.append("voucher_id", id);
    rdata.append("redeem", "extend");
    rdata.append("stripe_amount", amount.amount);
    rdata.append("months", amount?.duration);

    try {
      const response = await post(server_domain, rdata);

      if (response.data.message === "SUCCESS") {
        setClientSecret(response.data.clientSecret);
      } else if (response.data.error) {
        dispatch(
          setError({
            isShow: true,
            alert_title: response.data.alert_title,
            alert_text: response.data.alert_text,
            alert_action_button_title: response.data.alert_action_button_title,
            alert_action_url: response.data.alert_action_url,
            message: response.data.message,
          })
        );
      }
    } catch (err) {
      setError({
        isShow: true,
        alert_title: "Error",
        alert_text: "",
        alert_action_button_title: "",
        alert_action_url: "",
        message: err.toString(),
      });
    }
  };

  const loadProfile = async () => {
    let formData = getFormObj();
    formData.append("api_method", "load_profile");
    formData.append("user_id", user_id);

    try {
      const response = await post(server_domain, formData);
      if (response.data.message === "SUCCESS") {
        const { stripe_public_key } = response.data.user;
        setStripePromise(loadStripe(stripe_public_key));
      } else if (response.data.error) {
        dispatch(
          setError({
            isShow: true,
            alert_title: response.data.alert_title,
            alert_text: response.data.alert_text,
            alert_action_button_title: response.data.alert_action_button_title,
            alert_action_url: response.data.alert_action_url,
            message: response.data.message,
          })
        );
      }
    } catch (err) {
      dispatch(
        setError({
          isShow: true,
          alert_title: "Error",
          alert_text: "",
          alert_action_button_title: "",
          alert_action_url: "",
          message: err.toString(),
        })
      );
    }
  };

  useEffect(() => {
    if (!amount || !isAuthenticated) return;
    loadProfile();
    getStripeIntent();
    setOrderCompleteMessage("");
  }, [amount]);

  return (
    <Modal show={show} onHide={close} centered>
      {!isAuthenticated ? (
        <ModalBody className="fs-4" style={{ color: "#ababab" }}>
          <div className="d-flex justify-content-between gap-4">
            <p>
              Please log in with email: {email} to make card payments for this
              voucher.
            </p>
            <IoIosClose style={{ cursor: "pointer" }} onClick={close} />
          </div>
          <div className="d-flex justify-content-between">
            <button
              onClick={() => navigate("/login")}
              style={{ cursor: "pointer" }}
              className="btn btn-lg btn-block cont-shop"
              type="submit"
            >
              Login
            </button>
            <button
              onClick={close}
              style={{ cursor: "pointer" }}
              className="btn btn-lg btn-block cont-shop"
              type="submit"
            >
              Back
            </button>
          </div>
        </ModalBody>
      ) : (
        <Elements stripe={stripePromise}>
          <Modal.Body>
            {orderCompleteMessage ? (
              <div>
                <p className="text-center">{orderCompleteMessage}</p>
                <div className="text-center">
                  <button
                    onClick={close}
                    style={{ cursor: "pointer" }}
                    className="btn btn-lg btn-block cont-shop"
                    type="submit"
                  >
                    Back
                  </button>
                </div>
              </div>
            ) : (
              <ExtendCheckoutForm
                amount={amount}
                clientSecret={clientSecret}
                onSuccessfulCheckout={(m) => setOrderCompleteMessage(m)}
                reload={reload}
                id={id}
              />
            )}
          </Modal.Body>
        </Elements>
      )}
    </Modal>
  );
};

export default ExtendModal;
